import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { observer } from "mobx-react";
import useStores from "../../utils/useStores";
import AuthShell from "./AuthShell";

function Register() {
    const rootStore = useStores();
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    function handleSubmit(e: React.FormEvent) {
        e.preventDefault();
        setError("");

        if (password !== confirmPassword) {
            setError("Passwords do not match.");
            return;
        }

        setLoading(true);
        rootStore.profileStore.signUp(email, username, password, confirmPassword, (hasError: boolean, _type: string, message: string) => {
            setLoading(false);
            if (hasError) {
                setError(message || "Registration failed. Please try again.");
            } else {
                navigate("/");
            }
        });
    }

    return (
        <AuthShell eyebrow="Join Lrner" title="Create an account" description="One quiet identity for Vibes, Historic News, and everything still taking shape.">
                <form className="auth-form" onSubmit={handleSubmit}>
                    <div className="auth-field">
                        <label htmlFor="register-email">Email</label>
                        <input
                            id="register-email"
                            type="email"
                            autoComplete="email"
                            placeholder="Email Address"
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                            required
                        />
                    </div>
                    <div className="auth-field">
                        <label htmlFor="register-username">Username</label>
                        <input
                            id="register-username"
                            type="text"
                            autoComplete="username"
                            placeholder="Choose a username"
                            value={username}
                            onChange={e => setUsername(e.target.value)}
                            required
                        />
                    </div>
                    <div className="auth-field">
                        <label htmlFor="register-password">Password</label>
                        <input
                            id="register-password"
                            type="password"
                            autoComplete="new-password"
                            placeholder="At least 12 characters"
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                            minLength={12}
                            required
                        />
                    </div>
                    <div className="auth-field">
                        <label htmlFor="register-confirm-password">Confirm password</label>
                        <input
                            id="register-confirm-password"
                            type="password"
                            autoComplete="new-password"
                            placeholder="Repeat password"
                            value={confirmPassword}
                            onChange={e => setConfirmPassword(e.target.value)}
                            required
                        />
                    </div>

                    {error && (
                        <p className="auth-error" role="alert">{error}</p>
                    )}

                    <div className="auth-form__actions">
                        <button
                            type="submit"
                            disabled={loading}
                            className="auth-button"
                        >
                            {loading ? "Creating account…" : "Create account"}
                        </button>
                        <p className="auth-form__meta auth-form__meta--centered">
                            Already have an account?{" "}
                            <Link to="/login" className="auth-link">Sign in</Link>
                        </p>
                    </div>
                </form>
        </AuthShell>
    );
}

export default observer(Register);
